import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=ff2f3e1a&scoped=true&"
import script from "./DefaultPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=ff2f3e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f3e1a",
  null
  
)

export default component.exports